import { Navbar } from "@/components/Navbar";
import { Hero } from "@/components/Hero";
import { Marquee } from "@/components/Marquee";
import { Services } from "@/components/Services";
import { Fleet } from "@/components/Fleet";
import { Testimonials } from "@/components/Testimonials";
import { QuoteWidget } from "@/components/QuoteWidget";
import { BrandBand } from "@/components/BrandBand";
import { Footer } from "@/components/Footer";

export default function Home() {
  return (
    <main data-testid="home-page">
      <Navbar />
      <Hero />
      <Marquee />
      <Fleet />
      <QuoteWidget />
      <Services />
      <Testimonials />
      <BrandBand />
      <Footer />
    </main>
  );
}
